import React, { useCallback, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { showErrorToast, showSuccessToast } from '../../src/helpers/SweetAlert';
import { LoginAPI } from '../redux/actions/Auth/LoginAction';
import { AuthContext } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';


function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isPasswordShown, setIsPasswordShown] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const { login: contextLogin, isAuthenticated } = useContext(AuthContext);

    const { response, loading: loginLoading, error } = useSelector((state) => state.login);

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const validate = () => {
        let isValid = true;
        const newErrors = { email: '', password: '' };

        if (!email.trim()) {
            newErrors.email = 'Email is required';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = 'Email is invalid';
            isValid = false;
        }

        if (!password.trim()) {
            newErrors.password = 'Password is required';
            isValid = false;
        }

        if (!isValid) {
            setErrors(newErrors);
            setTimeout(() => {
                setErrors({});
            }, 2000);
        }

        return isValid; // ✅ always return
    };

    const handleSubmit = useCallback(async (event) => {
        event.preventDefault();

        if (validate()) {
            try {
                dispatch(LoginAPI({ email, password }));
            } catch (error) {
                console.log(error);
            }
        }
    }, [email, password, dispatch]);

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/admin-dashboard');
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {
        if (response?.status === true) {
            contextLogin(response?.data?.token);
            setEmail('');
            setPassword('');
            setErrors({ email: '', password: '' });
            showSuccessToast('Login successful!');
            navigate('/admin-dashboard');
        }
    }, [response, loginLoading, contextLogin, navigate]);

    useEffect(() => {
        if (error?.status === 400) {
            toast.dismiss();
            showErrorToast(error.data, "error");
        }
    }, [error]);

    // const handleSubmit = async (event) => {
    //     event.preventDefault();

    //     const newErrors = {};

    //     if (email.trim() === '') {
    //         newErrors.email = 'Email is required';
    //     }

    //     if (password.trim() === '') {
    //         newErrors.password = 'Password is required';
    //     }

    //     if (
    //         email.trim() !== '' &&
    //         password.trim() !== '' &&
    //         email !== 'admin@yopmail.com' &&
    //         password !== '12345678'
    //     ) {
    //         // newErrors.password = 'Incorrect password';
    //         showErrorToast('Incorrect email and password');
    //         setEmail('');
    //         setPassword('');
    //         return;
    //     } else if (
    //         email.trim() !== '' &&
    //         password.trim() !== '' &&
    //         email !== 'admin@yopmail.com'
    //     ) {
    //         // newErrors.email = 'Incorrect email';
    //         showErrorToast('Incorrect email');
    //         return;
    //     } else if (
    //         email.trim() !== '' &&
    //         password.trim() !== '' &&
    //         password !== '12345678'
    //     ) {
    //         showErrorToast('Incorrect password');
    //         return;
    //     }

    //     if (Object.keys(newErrors).length > 0) {
    //         setErrors(newErrors);

    //         // ✅ Clear errors after 2 seconds
    //         setTimeout(() => {
    //             setErrors({});
    //         }, 2000);

    //         return;
    //     }

    //     setErrors({});
    //     setLoading(true);

    //     // Simulate login success
    //     setTimeout(() => {
    //         showSuccessToast('Login Succesful')
    //         setLoading(false);
    //         navigate('/admin-dashboard');
    //     }, 1000);
    // };

    const togglePasswordVisibility = () => {
        setIsPasswordShown(!isPasswordShown);
    };

    return (
        <div className='admin-login'>
            <section className="login-section">
                <div className="container-fluid g-0">
                    <div className="row g-0">
                        <div className="col-md-5 d-none d-md-block">
                            <div className="login-img-blk">
                                <div className="img-blk">
                                    <img src="/assets/images/Image.png" alt="Banner" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="login-main-blk">
                                {/* <div className="login-logo">
                                    <p>Farmers</p>
                                    <a href="#">
                                        <img src="/assets/images/Group.png" style={{ width: '100%', maxWidth: '100px' }} alt="logo" />
                                    </a>
                                </div> */}
                                <div className="login-form-blk">
                                    <h1>Welcome back!</h1>
                                    <p>Login to access all your data</p>
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <label htmlFor="email">Email</label>
                                            <input
                                                type="email"
                                                className={`form-control ${errors.email ? 'is-invalid' : 'is-valid'}`}
                                                id="email"
                                                placeholder="Enter your email address"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === ' ') {
                                                        e.preventDefault(); // Prevent space key from being entered
                                                    }
                                                }}
                                            />
                                            {errors.email && <div className="error-message">
                                                {errors.email}
                                            </div>}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="password">Password</label>
                                            <div className="p-relative">
                                                <input
                                                    type={isPasswordShown ? "text" : "password"}
                                                    className={`form-control ${errors.password ? 'is-invalid' : 'is-valid'}`}
                                                    id="password"
                                                    placeholder="Enter your password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === ' ') {
                                                            e.preventDefault(); // Prevent space key from being entered
                                                        }
                                                    }}
                                                />
                                                <span id="eye" onClick={togglePasswordVisibility}>
                                                    {isPasswordShown ? (
                                                        <i className="fa-solid fa-eye" id="eyeIcon"></i>
                                                    ) : (
                                                        <i className="fa-solid fa-eye-slash" id="eyeIcon"></i>
                                                    )}
                                                </span>
                                            </div>
                                            {errors.password && (
                                                <div className="error-message">
                                                    {errors.password}
                                                </div>
                                            )}
                                        </div>
                                        <div className="login-btn-blk">
                                            <button type="submit" className="primary-btn w-100 rounded-pill" disabled={loading}>
                                                {loading ? 'Logging in...' : 'Login'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div >
            </section >
        </div >
    );
}

export default Login;
